import React, { useEffect, useRef, useState } from "react";
import UnlimitInput from "./ui-kit/unlimit-input";
import { useForm } from "react-hook-form";
import UnlimitToggle from "./ui-kit/unlimit-toggle";
import UnlimitSubmitButton from "./ui-kit/unlimit-submit-button";
import httpService from "../services/http/thirdparty/third-party.service";
import notificationService from "../services/toaster.service";
import { store } from "../core/redux/store";
import { hydrateErrors } from "../utils/error.utils";
import { useTranslation } from "react-i18next";

const ThirdPartyDetail = ({ onHide, thirdParty }) => {
  const { t } = useTranslation();
  const { register, handleSubmit, formState, setValue, setError, reset } =
    useForm();
  const { errors } = formState;
  const [isLoading, setIsLoading] = useState(false);
  const modalRef = useRef();
  const { auth } = store.getState();
  const onSubmitForm = async (data) => {
    const user = auth.user;
    try {
      setIsLoading(true);
      const requestData = {
        user_name: data.user_name,
        // is_active: data.is_active ? 1 : 0,
        password: data.password,
        email: data.email,
        created_by: user.id,
      };
      if (thirdParty) {
        requestData.id = thirdParty.id;
        await updateThirdParty(requestData);
      } else {
        await createThirdParty(requestData);
      }
    } finally {
      setIsLoading(false);
    }
  };
  const createThirdParty = async (formData) => {
    try {
      const response = await httpService.createThirdParty(formData, true);
      if (response && response.status === 200) {
        notificationService.successMessage(
          t("thirdParty.thirdPartyCreateSuccess")
        );
        onHide();
        reset();
        modalHide();
      }
    } catch (error) {
      if (error.validation_error.errors) {
        hydrateErrors(error.validation_error.errors, setError);
      }
    }
  };
  const updateThirdParty = async (formData) => {
    try {
      const response = await httpService.updateThirdParty(formData, true);
      if (response && response.status === 200) {
        notificationService.successMessage(
          t("thirdPartyList.thirdPartyUpdateSuccess")
        );
        onHide();
        reset();
        modalHide();
      }
    } catch (error) {
      if (error.validation_error.errors) {
        hydrateErrors(error.validation_error.errors, setError);
      }
    }
  };
  const modalHide = () => {
    const cancelButton = document.querySelector(".btn-cancel");
    if (cancelButton) {
      cancelButton.click();
    }
  };
  useEffect(() => {
    if (thirdParty) {
      setValue("user_name", thirdParty.user_name);
      setValue("email", thirdParty.email);
      // setValue("is_active", thirdParty.is_active == 1 ? true : false);
    }
  }, [thirdParty]);

  useEffect(() => {
    const modalElement = modalRef.current;
    const handleShow = () => {
      console.log("Handle show");
    };
    const handleHide = () => {
      reset();
      onHide();
    };
    modalElement.addEventListener("show.bs.modal", handleShow);
    modalElement.addEventListener("hide.bs.modal", handleHide);

    return () => {
      modalElement.removeEventListener("show.bs.modal", handleShow);
      modalElement.removeEventListener("hide.bs.modal", handleHide);
    };
  }, [onHide]);
  return (
    <div>
      <div className="modal fade" id="add-department" ref={modalRef}>
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>{t("thirdParty.addThirdParty")}</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form autoComplete="off" onSubmit={handleSubmit(onSubmitForm)} >
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="mb-3">
                          <UnlimitInput
                            label={t("inputField.label.userName")}
                            id="user_name"
                            type="text"
                            placeholder={t("inputField.placeholder.enterUserName")}
                            register={register}
                            autoComplete="off"
                            rules={{
                              required: t("inputField.validation.required"),
                              pattern: {
                                value: /^[a-zA-Z\s]*$/,
                                message: t("inputField.validation.pattern"),
                              },
                              maxLength: {
                                value: 50,
                                message: t("inputField.validation.maxLength", {
                                  value: 50,
                                }),
                              },
                            }}
                            error={errors.name}
                            errorMessage={errors.name?.message}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <UnlimitInput
                          label={t("inputField.label.email")}
                          id="email"
                          type="email"
                          placeholder={t("inputField.placeholder.enterEmail")}
                          register={register}
                          autoComplete="off"
                          rules={{
                            required: t("inputField.validation.required"),
                            pattern: {
                              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                              message: t("inputField.validation.emailPattern"),
                            },
                          }}
                          error={errors.email}
                          errorMessage={errors.email?.message}
                        />
                      </div>
                      {!thirdParty && <div className="col-lg-12">
                        <UnlimitInput
                          label={t("inputField.label.password")}
                          id="password"
                          type="password"
                          placeholder={t(
                            "inputField.placeholder.enterPassword"
                          )}
                          autoComplete="off"
                          register={register}
                          rules={{
                            required: t("inputField.validation.required"),
                            minLength: {
                              value: 8,
                              message: t("inputField.validation.minLength", {
                                value: 8,
                              }),
                            },
                          }}
                          error={errors.password}
                          errorMessage={errors.password?.message}
                        />
                      </div>}
                      {/* <div className="input-blocks m-0">
                        <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                          <UnlimitToggle
                            label={t("inputField.label.status")}
                            id="is_active"
                            register={register}
                          />
                        </div>
                      </div> */}
                    </div>
                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                        {t("general.button.cancel")}
                      </button>
                      <UnlimitSubmitButton
                        label={
                          thirdParty
                            ? t("general.button.update")
                            : t("general.button.submit")
                        }
                        isLoading={isLoading}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThirdPartyDetail;
